import { AppBar, Tabs, Tab } from '@mui/material';
import { useQuery } from 'react-query';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC, useEffect, useState, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Page, PageTitleWithBack } from '../../../components';
import { getOptionInfo } from '../../../fetch';
import { IOptionInfo } from '../../../models';
import { GeneralInformation } from './general-information';

export const enum optionPages {
  genInfo
}
interface IAddEditOption {}

export const AddEditOption: FC<IAddEditOption> = () => {
  const classes = useStyles();
  const [optionName, setOptionName] = useState<string | null>(null);
  const [selectedPage, setSelectedPage] = useState<optionPages>(optionPages.genInfo);
  const [selectedTab, setSelectedTab] = useState(window.location.pathname);
  const [isDirtyForm, setDirtyForm] = useState<boolean>(false);
  const { optionId }: { optionId: string } = useParams();
  const history = useHistory();

  const {
    isLoading: isLoadingGeneralInfo,
    data: generalInfo,
    refetch: refetchGeneralInfo
  } = useQuery<IOptionInfo, Error>(
    ['option-general-info', optionId],
    () => getOptionInfo(optionId),
    {
      onSuccess: d => setOptionName(d.name),
      enabled: optionId !== 'add'
    }
  );

  useEffect(() => {
    if (window.location.href.includes('general-information')) {
      setSelectedPage(optionPages.genInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href, optionId]);

  const getOptionId = () => {
    return optionId ? optionId : 'add';
  };
  const optionLinks = useMemo(
    () =>
      [
        {
          name: 'General Information',
          url: `/development/options/${getOptionId()}/general-information`
        }
      ].filter(Boolean),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [optionId]
  );

  const showLoader = isLoadingGeneralInfo;
  const title = showLoader
    ? 'Loading...'
    : !optionName && optionId === 'add'
    ? 'Add Option'
    : optionName || 'Edit Option';

  return (
    <Page title={title}>
      <>
        <PageTitleWithBack
          title={title}
          backText="Back to options"
          backUrl="/development/options/manage-options"
        />
        {optionId !== 'add' && (
          <AppBar position="static" color="default" component="div" className={classes.tabBar}>
            <Tabs
              value={selectedTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(_, value) => {
                if (!isDirtyForm) {
                  setSelectedTab(value);
                  history.push(value);
                } else {
                  const result = window.confirm(
                    'You have unsaved changes, are you sure you want to exit?'
                  );
                  if (result) {
                    setSelectedTab(value);
                    history.push(value);
                  } else {
                    return;
                  }
                }
              }}
              variant="scrollable"
            >
              {optionLinks.map(link => {
                return (
                  <Tab
                    value={link.url}
                    key={link.name}
                    id={`${link.name}-information`}
                    aria-controls={`${link.name}-information`}
                    label={link.name}
                  />
                );
              })}
            </Tabs>
          </AppBar>
        )}
        {selectedPage === optionPages.genInfo && (
          <GeneralInformation
            setDirtyForm={setDirtyForm}
            generalInfo={generalInfo}
            isLoadingGeneralInfo={isLoadingGeneralInfo}
            refetchGeneralInfo={refetchGeneralInfo}
          />
        )}
      </>
    </Page>
  );
};

const useStyles = makeStyles(theme => ({
  tabBar: {
    marginTop: '-1rem',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey[400]}`
  }
}));
